<template>
    <section class="d-flex mt-5 mt-lg-0 bg-soft">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 d-flex align-items-center justify-content-center">
                    <div class="bg-white shadow border-0 rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                        <div class="text-center text-md-center mb-4 mt-md-0">
                            <h1 class="mb-0 h3">Emissor de Certificado</h1>
                        </div>
                        <form @submit.prevent="submit()" class="mt-4" autocomplete="off">
                            <!-- Form -->
                            <div class="form-group mb-4">
                                <label for="email">E-Mail</label>
                                <div class="input-group">
                                        <span class="input-group-text" id="basic-addon1">
                                            <svg class="icon icon-xs text-gray-600" fill="currentColor"
                                                 viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path
                                                d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path><path
                                                d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path></svg>
                                        </span>
                                    <input type="email" v-model="form.student_mail" name="student_mail" class="form-control"
                                           id="email" autofocus required>
                                </div>
                            </div>
                            <!-- End of Form -->
                            <div class="form-group">
                                <!-- Form -->
                                <div class="form-group mb-4">
                                    <label for="nascimento_at">Data de Nascimento</label>
                                    <div class="input-group">
                                            <span class="input-group-text" id="basic-addon2">
                                                <svg class="icon icon-xs text-gray-600" fill="currentColor"
                                                     viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path
                                                    fill-rule="evenodd"
                                                    d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                                    clip-rule="evenodd"></path>
                                                </svg>
                                            </span>
                                        <input type="text" name="student_birth_date"
                                               v-model="form.student_birth_date"
                                               v-mask="'##/##/####'"
                                               class="form-control"
                                               id="nascimento_at" required>
                                    </div>
                                </div>
                                <!-- End of Form -->
                            </div>
                            <div class="d-grid">
                                <button type="submit" class="btn btn-gray-800">Solicitar certificado</button>
                            </div>
                        </form>
                        <div class="d-flex justify-content-center align-items-center mt-5">
                                <span class="fw-normal">
                                    Precisa de ajudar?
                                    <a href="https://bettertech.com.br" target="_blank" class="fw-bold">Clique aqui</a>
                                </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="modalDefault">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h2 class="h6 modal-title">Cursos que você participou</h2>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <table class="table user-table table-hover align-items-center">
                            <thead>
                            <tr>
                                <th class="border-bottom">Curso</th>
                                <th class="border-bottom" colspan="2">Data</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(course, index) in courses" :key="index">
                                <td class="border-0">
                                    <span class="fw-normal">{{ course['course_name'] }}</span>
                                </td>
                                <td class="border-0">{{ course['class_start_date'] }}</td>
                                <td class="border-0" style="text-align: right">
                                    <a :href="'/reports-api/certificate?course=' + course.course_code + '&student=' + course.student_code"
                                       target="_blank">
                                        <button class="btn btn-sm btn-primary" type="button">
                                            <svg class="icon icon-xs me-2" fill="currentColor" viewBox="0 0 20 20"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M8.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 00-1.414-1.414L11 7.586V3a1 1 0 10-2 0v4.586l-.293-.293z"></path>
                                                <path
                                                    d="M3 5a2 2 0 012-2h1a1 1 0 010 2H5v7h2l1 2h4l1-2h2V5h-1a1 1 0 110-2h1a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5z"></path>
                                            </svg>
                                            <span>emitir</span>
                                        </button>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-link text-gray-600 ms-auto" data-bs-dismiss="modal">
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {Modal} from 'bootstrap'
import {useForm} from '@inertiajs/vue3'

export default {

    props: {
        courses: {
            type: Array,
            default: []
        },
        errors: {
            type: Object
        }
    },
    setup(){
        const form = useForm({
            token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            student_mail: '',
            student_birth_date: '',
        })

        function submit() {
            form.post('/certificates')
        }

        return {form, submit}
    },
    watch: {
        '$page.props.courses': {
            handler(courses) {
                (function ($) {
                    if (typeof courses !== "undefined" && courses.length) {
                        new Modal(document.getElementById('modalDefault')).show()
                    }
                })(jQuery);
            },
        },
    },
}
</script>

<style scoped>

</style>
